<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1 myclass" id="نرجسية"><div class="section level2" id="narcissistic" style="padding-top:130px">
<p><span dir="rtl">بدون الأحلام.. نحن لا نحقق شيئاً.</span></p>
<br/><br/>
<p style="text-align:center; direction:ltr">Without dreams we reach nothing.</p>
<br/>
<p><span dir="rtl">بدون الانسانية, نحنُ لسنا ببشر.</span></p>
<p style="text-align:center; direction:ltr">Without humanity, we’re not humans.</p>
<br/><p style="text-align:center">******</p>
<br/>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0006.vue?cd86d3c0